import React, { useState, useEffect } from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Table, 
  TableHead, 
  TableBody, 
  TableRow, 
  TableCell,
  makeStyles
} from '@material-ui/core';
import { useDataProvider, Loading, Error } from 'react-admin';
import moment from 'moment';

const useStyles = makeStyles({
  card: {
    marginTop: 20,
    marginBottom: 20,
  },
  title: {
    marginBottom: 16,
    fontWeight: 'bold',
  },
  tableCell: {
    padding: '8px 16px',
  },
  noHistory: {
    fontStyle: 'italic',
    color: '#666',
    padding: 16,
  }
});

const formatStatus = (status) => {
  if (status === 'draft') return 'драфтласан';
  if (status === 'comming_soon') return 'тун удахгүй';
  if (status === 'published') return 'нийтлэсэн';
  return status;
};

const CourseStatusHistory = ({ courseId }) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        setLoading(true);
        // Call the API endpoint for course status history
        const { data } = await dataProvider.getList('skills/courses/statusHistory', {
          pagination: { page: 1, perPage: 5 },
          sort: { field: 'updatedAt', order: 'DESC' },
          filter: { courseId },
        });
        setHistory(data);
        setLoading(false);
      } catch (e) {
        setError(e);
        setLoading(false);
      }
    };

    fetchHistory();
  }, [dataProvider, courseId]);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant="h6" className={classes.title}>
          Сүүлийн статусын өөрчлөлтүүд
        </Typography>

        {history.length > 0 ? (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableCell}>Огноо</TableCell>
                <TableCell className={classes.tableCell}>Хуучин статус</TableCell>
                <TableCell className={classes.tableCell}>Шинэ статус</TableCell>
                <TableCell className={classes.tableCell}>Админ имэйл</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map(item => (
                <TableRow key={item.id}>
                  <TableCell className={classes.tableCell}>
                    {moment(item.updatedAt).format('YYYY-MM-DD HH:mm')}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {formatStatus(item.previousStatus)}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {formatStatus(item.newStatus)}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {item.adminEmail || '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className={classes.noHistory}>Статусын өөрчлөлтийн түүх байхгүй байна.</div>
        )}
      </CardContent>
    </Card>
  );
};

export default CourseStatusHistory; 